import Index from "./UnionlyUpdateSubscription/index";

export default Index

